module.exports = __webpack_public_path__ + "img/01_uk.74156327.svg";